// extracted by mini-css-extract-plugin
export default {"done":"TabFiltrStatus_done__0skJr","canceled":"TabFiltrStatus_canceled__mfPsU","item":"TabFiltrStatus_item__N7XrC","popover":"TabFiltrStatus_popover__dJSpr"};